export const config = {
    nameOfBrandShops: 'brands/crisp/shops',
    nameOfBrandItems: 'brands/crisp/items',
    nameOfBrandDynamicLinks: 'brands/crisp/dynamic_links',
    nameOfBrandItemCategories: 'brands/crisp/item_categories',
    nameOfBrandOptionCategories: 'brands/crisp/option_categories',
    nameOfBrandOptions: 'brands/crisp/options',
    nameOfBrandFilteringOptionCategories:
        'brands/crisp/option_filtering_categories',
    nameOfBrandFilteringOptionItems: 'brands/crisp/option_filtering_items',

    STORY_PAGE_MAX_SIZE: 8,

    BREADCRUMB_ITEMS: [
        {
            key: 1,
            text: 'CRISP TOP',
            href: '/',
        },
        {
            key: 2,
            text: 'STORIES',
            href: '/stories',
        },
    ],
};

export default config;
